import { render } from "./BadgesCard.vue?vue&type=template&id=35dcc210&scoped=true"
import script from "./BadgesCard.vue?vue&type=script&lang=js"
export * from "./BadgesCard.vue?vue&type=script&lang=js"

import "./BadgesCard.vue?vue&type=style&index=0&id=35dcc210&scoped=true&lang=css"

import exportComponent from "C:\\Users\\alexg\\Desktop\\martech\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35dcc210"]])

export default __exports__